import request from '@/utils/request'

// 订单号查询订单重定向
export function login() {
    return request({
        url: '/index/category',
        method: 'get'
    })
}

// 首页接口
export function home() {
    return request({
        url: '/index/index',
        method: 'get'
    })
}

// mindfulness exercises
export function mindfulnessexercises() {
    return request({
        url: '/index/index/mindfulnessexercises',
        method: 'get'
    })
}

// mindsteps
export function mindsteps() {
    return request({
        url: '/index/index/mindsteps',
        method: 'get'
    })
}

// podcast episodes
export function podcastepisodes() {
    return request({
        url: '/index/index/podcastepisodes',
        method: 'get'
    })
}

// youth mind youthmindfulnessvideos
export function youthmindfulnessvideos() {
    return request({
        url: '/index/index/youthmindfulnessvideos',
        method: 'get'
    })
}

// youth mind youthmindfulnessapps
export function youthmindfulnessapps() {
    return request({
        url: '/index/index/youthmindfulnessapps',
        method: 'get'
    })
}

//professionalsupportforyouth
export function professionalsupportforyouth() {
    return request({
        url: '/index/index/professionalsupportforyouth',
        method: 'get'
    })
}

// mindfulnessjournal
export function mindfulnessjournal() {
    return request({
        url: '/index/index/mindfulnessjournal',
        method: 'get'
    })
}

// mindfulnesscalendar
export function mindfulnesscalendar() {
    return request({
        url: '/index/index/mindfulnesscalendar',
        method: 'get'
    })
}

// aboutinfo
export function aboutinfo() {
    return request({
        url: '/index/index/aboutinfo',
        method: 'get'
    })
}

// getcontact
export function getcontact() {
    return request({
        url: '/index/index/getcontact',
        method: 'get'
    })
}

// ajax_add   留言接口
export function ajaxAdd(data) {
    return request({
        url: '/index/index/ajax_add',
        method: 'post',
        data: data
    })
}

//四个小图标
export function geticonlist() {
    return request({
        url: '/index/index/geticonlist',
        method: 'get'
    })
}
